// Action Types

export const Types = {
  GET_PROJECT_REQUESTED: 'customer/GET_PROJECT_REQUESTED',
  GET_PROJECT_SUCCEEDED: 'customer/GET_PROJECT_SUCCEEDED',
  GET_PROJECT_FAILED: 'customer/GET_PROJECT_FAILED',
}

// Action Creators

export function getProject() {
  return {
    type: Types.GET_PROJECT_REQUESTED,
  }
}

// Reducer

const INITIAL_STATE = {
  getProjectIsLoading: false,
  getProjectError: null,
  project: null,
}

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_PROJECT_REQUESTED:
      return {
        ...state,
        geProjectIsLoading: true,
      }
    case Types.GET_PROJECT_SUCCEEDED:
      return {
        ...state,
        geProjectIsLoading: false,
        geProjectError: null,
        project: action.payload,
      }
    case Types.GET_PROJECT_FAILED:
      return {
        ...state,
        geProjectIsLoading: false,
        geProjectError: action.payload,
        project: null,
      }

    default:
      return state
  }
}
